namespace Matrix.Data {
    export interface JpmSecClassResultRow {
        SecurityId?: string;
        MxInputSignature?: string;
        SecTypeCode?: string;
        Industry?: string;
        DaysToMaturity?: string;
        MaturityBand?: string;
        CountryOfExposure?: string;
        CurrencyOfExposure?: string;
        EmergingMarket?: string;
        AaSector?: string;
        CounterpartyOrIssuer?: string;
        CountryOfIssue?: string;
    }

    export namespace JpmSecClassResultRow {
        export const idProperty = 'SecurityId';
        export const nameProperty = 'SecurityId';
        export const localTextPrefix = 'Data.JpmSecClassResult';
        export const deletePermission = 'NoPermission';
        export const insertPermission = 'NoPermission';
        export const readPermission = 'Read:JPMSecClassResult';
        export const updatePermission = 'NoPermission';

        export declare const enum Fields {
            SecurityId = "SecurityId",
            MxInputSignature = "MxInputSignature",
            SecTypeCode = "SecTypeCode",
            Industry = "Industry",
            DaysToMaturity = "DaysToMaturity",
            MaturityBand = "MaturityBand",
            CountryOfExposure = "CountryOfExposure",
            CurrencyOfExposure = "CurrencyOfExposure",
            EmergingMarket = "EmergingMarket",
            AaSector = "AaSector",
            CounterpartyOrIssuer = "CounterpartyOrIssuer",
            CountryOfIssue = "CountryOfIssue"
        }
    }
}
